import { Schema } from "@comparaonline/quoter-schema";
import React from "react";
import { Query, QueryProps } from "react-apollo";
import { useAppContext } from "../../../lib/appContext";
import { getOffers } from "../getOffers";

export enum QueryName {
  cibrOffers = "cibrOffers",
  cicoOffers = "cicoOffers",
  ciclOffers = "ciclOffers"
}

export interface OfferResponse {
  id: string;
  formId: string;
  product: Schema.Product;
}

export type OffersData = Record<QueryName, OfferResponse[]>;

export interface OffersVariables {
  offerIds: string[];
}

class BaseQuery extends Query<OffersData, OffersVariables> {}

export interface IOffersQueryProps
  extends Pick<QueryProps<OffersData, OffersVariables>, "children"> {
  variables: OffersVariables;
}

export const OffersQuery: React.FC<IOffersQueryProps> = ({ children, variables }) => {
  const { countryCode } = useAppContext();
  return (
    <BaseQuery query={getOffers(countryCode)} variables={{ offerIds: variables.offerIds }}>
      {response => children(response)}
    </BaseQuery>
  );
};
